import { modifyImageUrlQueryParams } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

export const imageSettings = {
  aspectRatio: 0.75,
  defaultWidth: 434,
};

export const generateSrcSet = (urlOfImage: string) => {
  const { defaultWidth, aspectRatio } = imageSettings;
  const widthSettings = [defaultWidth, defaultWidth * 2];
  const srcSet = widthSettings.map(
    (width, index) =>
      `${modifyImageUrlQueryParams(urlOfImage, {
        wid: width,
        hei: Math.round(Number(width) / aspectRatio),
      })} ${index + 1}x`,
  );

  return { src: srcSet[0]?.split(" ")[0], srcSet: srcSet.join(", ") };
};
